module.exports = __webpack_public_path__ + "img/quizz-step-6-1.d7905096.jpg";